import React from 'react';
import PageLayout from '../components/PageLayout';
import Hero from '../components/Hero';
import CTASection from '../components/CTASection';
import useBrand from '../branding/useBrand';
import useDocumentTitle from '../hooks/useDocumentTitle';
import './Page.css';
import './TechnologyPage.css';

function TechnologyPage() {
  const content = useBrand().pages.technology;
  useDocumentTitle(content.title);

  return (
    <PageLayout
      hero={(
        <Hero
          title={content.heroTitle}
          lead={content.heroLead}
        />
      )}
    >
      <div className="technology-page">
        <section className="page-section technology-intro">
          <span className="technology-eyebrow">{content.introEyebrow}</span>
          <h2>{content.introTitle}</h2>
          <p>
            {content.introBody}
          </p>
        </section>

        <section className="page-section technology-standards-grid" aria-label={content.standardsAriaLabel}>
          {content.standards.map((card) => (
            <article key={card.title} className="technology-standard-card">
              <img src={card.image} alt={card.alt} />
              <div>
                <h3>{card.title}</h3>
                <p>{card.description}</p>
              </div>
            </article>
          ))}
        </section>

        <section className="page-section technology-ocpp-section">
          <div className="technology-section-copy">
            <span className="technology-eyebrow">{content.ocppEyebrow}</span>
            <h2>{content.ocppTitle}</h2>
            <p>
              {content.ocppBody}
            </p>
          </div>
          <div className="technology-message-grid">
            {content.ocppGroups.map((group) => (
              <article key={group.title} className="technology-message-card">
                <h3>{group.title}</h3>
                <ul>
                  {group.items.map((item) => (
                    <li key={item}><code>{item}</code></li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        </section>

        <section className="page-section technology-split-section">
          <div className="technology-section-copy">
            <span className="technology-eyebrow">{content.transportEyebrow}</span>
            <h2>{content.transportTitle}</h2>
            <p>
              {content.transportBody}
            </p>
          </div>
          <div className="technology-transport-panel">
            {content.transportFacts.map((fact) => (
              <div key={fact.label}>
                <span>{fact.label}</span>
                <code>{fact.value}</code>
              </div>
            ))}
          </div>
        </section>

        <section className="page-section technology-integration-section">
          <header className="section-header">
            <span className="technology-eyebrow">{content.integrationEyebrow}</span>
            <h2 className="section-heading">{content.integrationTitle}</h2>
            <p className="section-subhead">
              {content.integrationBody}
            </p>
          </header>
          <div className="technology-integration-grid">
            {content.integrationLayers.map((layer) => (
              <article key={layer.title}>
                <h3>{layer.title}</h3>
                <p>{layer.description}</p>
              </article>
            ))}
          </div>
        </section>

        <CTASection />
      </div>
    </PageLayout>
  );
}

export default TechnologyPage;
